import React, {CSSProperties, useLayoutEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';

import classNames from 'classnames';

import {remToPx} from '@dvrd/dvr-controls';

interface Props {
    text: string | undefined;
    className?: string;
    children: React.ReactElement;
}

const SCREEN_PADDING = remToPx(1);

export default function Tooltip(props: Props) {
    const {text, children, className} = props;
    const [visible, setVisible] = useState(false);
    const [style, setStyle] = useState<CSSProperties>({top: 0, left: 0});
    const ref = useRef<HTMLElement>(null);
    const tooltipRef = useRef<HTMLDivElement>(null);

    function show() {
        if (!text || !ref.current) return;
        const rect = ref.current.getBoundingClientRect();
        setStyle({
            top: rect.top - 4,
            left: rect.left + rect.width / 2
        });
        setVisible(true);
    }

    function hide() {
        setVisible(false);
    }

    /** Reposition tooltips that fall off the left edge of the screen. */
    function fixPosition() {
        const tooltip = tooltipRef.current;
        if (!tooltip) return;
        const renderedLeft = tooltip.getBoundingClientRect().left;
        if (renderedLeft - SCREEN_PADDING < 0) setStyle({...style, left: remToPx(1), transform: 'translateY(-50%)'});
    }

    useLayoutEffect(() => {
        if (visible) fixPosition();
    }, [visible]);

    return (
        <>
            {React.cloneElement(children, {
                // @ts-expect-error – ref forwarding for DOM elements
                ref,
                onMouseEnter: show,
                onMouseLeave: hide
            })}
            {visible &&
                text &&
                createPortal(
                    <div ref={tooltipRef} className={classNames('sr-tooltip-portal', className)} style={style}>
                        {text}
                    </div>,
                    document.body
                )}
        </>
    );
}
